import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/vant.js'
import './style/components.css'
import vueSignature from "vue-signature";

Vue.config.productionTip = false
Vue.component('vueSignature', vueSignature)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
